import React from 'react';
import { useLanguage } from './index';
import './language.css';

export default function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();
  return (
    <div className="bb-language-bar">
      <button type="button" className="bb-language-toggle" onClick={() => setLanguage(language === 'ar' ? 'en' : 'ar')}
        aria-label={language === 'ar' ? 'Switch to English' : 'التبديل إلى العربية'}
        lang={language === 'ar' ? 'en' : 'ar-SA'} dir={language === 'ar' ? 'ltr' : 'rtl'}>
        <span aria-hidden="true">◎</span> {language === 'ar' ? 'English' : 'العربية'}
      </button>
    </div>
  );
}
